import { Loading } from 'element-ui';

const loadOption={fullscreen: true ,lock: true, text: '', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.2)'}

let loadingInstance;
let loadingCount = 0
export default class loadEvents {
    constructor(vueThis){
        this.vm = vueThis ;  //vue中的this  也可以不用
    }
    open(){
        loadingInstance = Loading.service(loadOption);
    }
    close(){
         loadingCount--;

          if (loadingInstance ) {
            loadingInstance.close()
            loadingInstance = null
          }
    }
}
